export default __webpack_public_path__ + "static/media/mail.d1975dfe.svg";